import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api_getGifts, api_getGiftsByFilter } from '../../api/gift'; // Adjusted import for Gift APIs
import Input from '../../components/bootstrap/forms/Input';
import Icon from '../../components/icon/Icon';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import SubHeader, {
	SubHeaderLeft,
	SubHeaderRight,
	SubheaderSeparator,
} from '../../layout/SubHeader/SubHeader';
import Card, {
	CardActions,
	CardBody,
	CardHeader,
	CardLabel,
	CardTitle,
} from '../../components/bootstrap/Card';
import Button from '../../components/bootstrap/Button';

const PAGE_SIZE = 5;

const Item = ({ item, removeGiftFromTable, index }: any) => {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	return (
		<tr key={index}>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.gifter?.name}</div>{' '}
						{/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.promoCode}</div>{' '}
						{/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.amount}</div>{' '}
						{/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.for}</div>{' '}
						{/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.friend1}</div>{' '}
						{/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.friend2}</div>{' '}
						{/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.friend3}</div>{' '}
						{/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<div className='d-flex'>
					<div className='flex-grow-1'>
						<div className='fs-6 fw-bold'>{item?.status}</div>{' '}
						{/* Display event type name */}
					</div>
				</div>
			</td>
			<td>
				<span
					onClick={() => navigate(`/edit/gift`, { state: item })} // Navigate to edit event type route
					style={{ margin: 10, cursor: 'pointer' }}>
					EDIT
				</span>
			</td>
		</tr>
	);
};

const AllGift = () => {
	const [gifts, setGifts] = useState<any>([]); // State variable to hold event types
	const [loading, setLoading] = useState(false);
	const [pageNo, setPageNo] = useState(1);
	const [hasMore, setHasMore] = useState(true);
	const navigate = useNavigate();
	const tableBodyRef = useRef<HTMLTableSectionElement>(null);
	const [filter, setFilter] = useState(false);
	const [searchString, setSearchString] = useState('');

	// Function to fetch event types
	const getGifts = async (page_no?: number) => {
		const finalPageNo = page_no || pageNo;

		try {
			setLoading(true);
			const res = await api_getGifts(finalPageNo, PAGE_SIZE); // Fetch event types from API

			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
				} else {
					if (page_no === 1) {
						setGifts(res.data);
						setPageNo(2);
					} else {
						setGifts([...gifts, ...res.data]);
						setPageNo(pageNo + 1);
					}
				}
			} else {
				console.error('Failed to fetch event types:', res.message);
			}
		} catch (error) {
			console.error('Error fetching event types:', error);
		} finally {
			setLoading(false);
		}
	};

	const getGiftsByFilter = async () => {
		try {
			setLoading(true);
			const res = await api_getGiftsByFilter(searchString);
	
			if (res.isSuccess) {
				if (!res.data.length) {
					setHasMore(false);
					return;
				}
				setGifts(res.data);
			}
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	// Function to remove event type from table
	const removeGiftFromTable = (giftId: string) => {
		setGifts(gifts.filter((e: any) => e._id !== giftId));
	};

	// Load more event types
	const onLoadMore = () => {
		if (hasMore) {
			getGifts();
		}
	};

	// Handle filter reset
	const handleFilterReset = () => {
		setGifts([]);
		setHasMore(true);
		getGifts(1);
	};

	// Fetch event types on component mount
	useEffect(() => {
		getGifts();
	}, []);

	// Add scroll event listener to table body
	useEffect(() => {
		tableBodyRef.current?.addEventListener('scroll', (e) => {
			console.log(e);
		});
	}, []);

	return (
		<PageWrapper title={'Event Types'}>
			<div style={{ marginTop: '20px' }}>
				<SubHeader>
					<SubHeaderLeft>
						<label
							className='border-0 bg-transparent cursor-pointer me-0'
							htmlFor='searchInput'>
							<Icon
								icon='Search'
								size='2x'
								color='primary'
								onClick={() => {
									setGifts([]);
									setHasMore(true);
									getGiftsByFilter();
								}}
							/>
						</label>
						<Input
							value={searchString}
							onChange={(e: any) => setSearchString(e?.target?.value)}
							id='searchInput'
							type='search'
							className='border-0 shadow-none bg-transparent'
							placeholder='Search gifts...'
						/>
					</SubHeaderLeft>
				</SubHeader>
			</div>
			<Card stretch>
				<CardHeader borderSize={1}>
					<CardLabel icon='Alarm' iconColor='info'>
						<CardTitle>All Gifts</CardTitle>
					</CardLabel>
					{/* <CardActions>
						<Button
							onClick={() => navigate('/add/gift')}
							icon='PersonAdd'
							color='primary'
							isLight={true}>
							New Gift
						</Button>
					</CardActions> */}
				</CardHeader>
				<CardBody isScrollable className='table-responsive'>
					<table className='table table-modern'>
						<thead>
							<tr>
								<th>Customer Name</th>
								<th>Promo Code</th>
								<th>Amount</th>
								<th>For</th>
								<th>Friend1</th>
								<th>Friend2</th>
								<th>Friend3</th>
								<th>Status</th>
								<th>Action</th>
							</tr>
						</thead>
						<tbody>
							{gifts?.map((item: any, index: any) => (
								<Item
									key={index}
									item={item}
									index={index}
									removeGiftFromTable={removeGiftFromTable}
								/>
							))}
						</tbody>
					</table>
					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							marginBottom: '20px',
						}}>
						{hasMore && (
							<button
								style={{
									border: 'none',
									padding: '10px',
									borderRadius: '10px',
									cursor: 'pointer',
								}}
								onClick={onLoadMore}>
								Load More...
							</button>
						)}
					</div>
				</CardBody>
			</Card>
		</PageWrapper>
	);
};

export default AllGift;
